import { InputAdornment, TextField } from "@mui/material";

import { getSettlementModalTextFieldSx } from "../../../style/styles";

export default function OtherLiensBalanceTextField({
  fieldName,
  fieldValue,
  onChange,
  inputMode = "text",
  pattern,
  startAdornment,
}) {
  const handleChange = (event) => {
    const nextValue = event.target.value;

    if (pattern && !pattern.test(nextValue)) {
      return;
    }

    onChange(fieldName, nextValue);
  };

  return (
    <TextField
      className="w-full"
      size="small"
      value={fieldValue}
      onChange={handleChange}
      sx={getSettlementModalTextFieldSx()}
      inputProps={{ inputMode }}
      InputProps={{
        startAdornment: startAdornment ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : null,
      }}
    />
  );
}
